<div class="dashboard-wrapper" [style.background]="bgColor">

  <!-- ═══════════════════════════ HEADER BANNER ═══════════════════════════ -->
  <div class="dash-banner" [style.background]="'linear-gradient(135deg, ' + primaryColor + ' 0%, ' + secondaryColor + ' 100%)'">
    <div class="banner-left">
      <img
        [src]="logoUrl"
        [alt]="etablissementNom"
        class="banner-logo"
        (error)="logoUrl = 'assets/img/monkey.png'"
      />
      <div class="banner-text">
        <h1 class="banner-title">{{ etablissementNom || ('ADMIN_DASHBOARD.DEFAULT_TITLE' | translate) }}</h1>
        <p class="banner-subtitle">{{ 'ADMIN_DASHBOARD.SUBTITLE' | translate }}</p>
      </div>
    </div>
    <div class="banner-date">
      <span class="today-label">{{ 'ADMIN_DASHBOARD.TODAY_LABEL' | translate }}</span>
      <span class="today-date">{{ today }}</span>
    </div>
  </div>

  <!-- ═══════════════════════════ LOADING SKELETON ═══════════════════════════ -->
  <div class="skeleton-grid" *ngIf="isLoading">
    <div class="skeleton-card" *ngFor="let i of [1,2,3,4,5]"></div>
  </div>

  <!-- ═══════════════════════════ KPI CARDS ═══════════════════════════ -->
  <div class="kpi-grid" *ngIf="!isLoading">
    <div
      class="kpi-card"
      *ngFor="let card of kpiCards; let i = index; trackBy: trackByIndex"
      [style.border-top]="'3px solid ' + card.color"
    >
      <div class="kpi-icon-wrap" [style.background]="card.bg">
        <span class="kpi-icon">{{ card.icon }}</span>
      </div>
      <div class="kpi-info">
        <span class="kpi-value" [style.color]="card.color">{{ card.value }}</span>
        <span class="kpi-title">{{ card.titleKey | translate }}</span>
        <span class="kpi-trend">{{ card.trendKey | translate }}</span>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════ CHARTS ROW 1 ═══════════════════════════ -->
  <div class="charts-row" *ngIf="!isLoading">

    <!-- BUG FIX: Selected class stats panel (shown when a bar is clicked) -->
    <div *ngIf="selectedClassStats" class="class-stats-panel" style="margin-bottom: 16px; padding: 16px; background: white; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.06); display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;">
      <div style="display: flex; align-items: center; gap: 12px;">
        <span style="font-size: 28px;">🏫</span>
        <div>
          <h4 style="margin: 0; font-weight: 700; font-size: 18px;" [style.color]="primaryColor">{{ selectedClassStats!.label }}</h4>
          <p style="margin: 4px 0 0; color: #64748b; font-size: 14px;">
            <strong [style.color]="primaryColor">{{ selectedClassStats!.count }}</strong> élève(s) inscrit(s)
          </p>
        </div>
      </div>
      <button (click)="clearClassSelection()" style="background: none; border: 1px solid #e2e8f0; border-radius: 8px; padding: 6px 12px; cursor: pointer; color: #64748b; font-size: 13px;">× Fermer</button>
    </div>

    <!-- Bar Chart – Students per Class -->
    <div class="chart-card wide animate-in" style="--anim-delay: 200ms">
      <div class="chart-card-header">
        <div class="chart-card-title">
          <span class="chart-dot" [style.background]="primaryColor"></span>
          {{ 'ADMIN_DASHBOARD.ELEVES_PAR_CLASSE' | translate }}
        </div>
        <span class="chart-badge" [style.background]="hexToRgba(primaryColor, 0.12)" [style.color]="primaryColor">
          {{ stats.totalClasses }} {{ 'ADMIN_DASHBOARD.CLASSES_COUNT' | translate }}
        </span>
      </div>
      <div class="chart-body" style="height: 240px">
        <canvas
          baseChart
          [data]="barChartData"
          [options]="barChartOptions"
          [type]="barChartType"
          *ngIf="stats.elevesByClass.length > 0; else noDataBar"
        ></canvas>
        <ng-template #noDataBar>
          <div class="no-data">
            <span>🏫</span>
            <p>{{ 'ADMIN_DASHBOARD.NO_CLASS' | translate }}</p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Doughnut Chart – People overview -->
    <div class="chart-card animate-in" style="--anim-delay: 300ms">
      <div class="chart-card-header">
        <div class="chart-card-title">
          <span class="chart-dot" [style.background]="secondaryColor"></span>
          {{ 'ADMIN_DASHBOARD.REPARTITION' | translate }}
        </div>
      </div>
      <div class="chart-body doughnut-wrap" style="height: 240px">
        <canvas
          baseChart
          [data]="doughnutChartData"
          [options]="doughnutChartOptions"
          [type]="doughnutChartType"
          *ngIf="stats.totalParents + stats.totalEducateurs + stats.totalEmployees > 0; else noDataDoughnut"
        ></canvas>
        <!-- Center label -->
        <div class="doughnut-center" *ngIf="stats.totalParents + stats.totalEducateurs + stats.totalEmployees > 0">
          <span class="doughnut-total" [style.color]="primaryColor">
            {{ stats.totalParents + stats.totalEducateurs + stats.totalEmployees }}
          </span>
          <span class="doughnut-label">{{ 'ADMIN_DASHBOARD.TOTAL' | translate }}</span>
        </div>
        <ng-template #noDataDoughnut>
          <div class="no-data"><span>👥</span><p>{{ 'ADMIN_DASHBOARD.NO_USER' | translate }}</p></div>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════ CHARTS ROW 2 ═══════════════════════════ -->
  <div class="charts-row" *ngIf="!isLoading">

    <!-- Line Chart – New parents per month -->
    <div class="chart-card wide animate-in" style="--anim-delay: 400ms">
      <div class="chart-card-header">
        <div class="chart-card-title">
          <span class="chart-dot" [style.background]="secondaryColor"></span>
          {{ 'ADMIN_DASHBOARD.NEW_PARENTS' | translate }}
        </div>
        <span class="chart-badge" [style.background]="hexToRgba(secondaryColor, 0.12)" [style.color]="secondaryColor">
          {{ stats.totalParents }} {{ 'ADMIN_DASHBOARD.TOTAL_LABEL' | translate }}
        </span>
      </div>
      <div class="chart-body" style="height: 220px">
        <div *ngIf="lineChartData?.datasets?.[0]?.data?.length; else noDataLine" style="height:100%">
          <canvas
            baseChart
            [data]="lineChartData"
            [options]="lineChartOptions"
            [type]="lineChartType"
          ></canvas>
        </div>
        <ng-template #noDataLine>
          <div class="no-data"><span>📈</span><p>{{ 'ADMIN_DASHBOARD.NO_DATA' | translate }}</p></div>
        </ng-template>
      </div>
    </div>

    <!-- Summary stats panel -->
    <div class="chart-card animate-in" style="--anim-delay: 500ms">
      <div class="chart-card-header">
        <div class="chart-card-title">
          <span class="chart-dot" [style.background]="editColor"></span>
          {{ 'ADMIN_DASHBOARD.QUICK_SUMMARY' | translate }}
        </div>
      </div>
      <div class="summary-list">
        <div class="summary-item" *ngFor="let card of kpiCards">
          <div class="summary-icon" [style.background]="card.bg">{{ card.icon }}</div>
          <div class="summary-info">
            <span class="summary-name" [style.color]="titleColor">{{ card.titleKey | translate }}</span>
            <div class="summary-bar-track">
              <div
                class="summary-bar-fill"
                [style.background]="card.color"
                [style.width]="getBarWidth(card.value) + '%'"
              ></div>
            </div>
          </div>
          <span class="summary-count" [style.color]="card.color">{{ card.value }}</span>
        </div>
      </div>
    </div>
  </div>

</div>
